export default __webpack_public_path__ + "static/media/js.75fa9cdf.svg";